(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["core-search"]) return;
  try {
    
  // To make sure the results are product type

  // Create a URL object for the URL string
  const url = new URL(window.location.href)

  // Create an instance of URLSearchParams from the URL
  const params = new URLSearchParams(url.search)

  const type = params.get('type')

  if (type !== 'product') {
    params.set('type', 'product')

    // Update the search property of the URL object with the new query string
    // This step does not remove or alter other parameters you haven't explicitly changed.
    url.search = params.toString()

    // Assign the updated URL to window.location.href to trigger a page reload.
    // This reloads the page with the new query parameters, keeping all other parameters intact.
    window.location.href = url.toString()
  }

  } catch(e) { console.error(e); }
})();
})();
